import { cn } from '@/lib/utils';
import { Content } from '@/components/layout/Content';
import { PageMainProps } from './types';
import { usePageShellContext } from '../../context';

const footerPaddingClassNames = {
  fixed: 'pb-[calc(4rem+env(safe-area-inset-bottom)+1rem)] min-[769px]:pb-[calc(4rem+max(env(safe-area-inset-bottom),2rem))]',
  static: 'pb-4 min-[769px]:pb-8'
};

const headerPaddingClassNames = {
  fixed: {
    face: 'pt-[env(safe-area-inset-top)] min-[769px]:pt-0',
    flow: 'pt-[calc(env(safe-area-inset-top)+1.5rem)] min-[769px]:pt-6'
  },
  static: {
    face: '',
    flow: 'pt-6'
  }
};

const PageMain = (props: PageMainProps) => {
  const {
    children,
    className,
    contentClassName
  } = props;

  const {
    contentVariant,
    footerMode,
    headerMode
  } = usePageShellContext();

  return (
    <main
      className={cn(
        'flex w-full flex-1 flex-col',
        footerPaddingClassNames[footerMode],
        headerPaddingClassNames[headerMode][contentVariant],
        className
      )}
    >
      <Content
        className={contentClassName}
        variant={contentVariant}
      >
        {children}
      </Content>
    </main>
  );
};

export default PageMain;